import api from './api';

export const medicalReportService = {
    // Create medical report
    createReport: async (data) => {
        try {
            const response = await api.post('/medical-report', data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to create medical report');
        }
    },

    // Get medical reports
    getReports: async (filters = {}) => {
        try {
            const params = new URLSearchParams(filters);
            const response = await api.get(`/medical-report?${params}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch medical reports');
        }
    },

    // Get single medical report
    getReport: async (reportId) => {
        try {
            const response = await api.get(`/medical-report/${reportId}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch medical report');
        }
    },

    // Update medical report
    updateReport: async (reportId, data) => {
        try {
            const response = await api.put(`/medical-report/${reportId}`, data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to update medical report');
        }
    },

    // Delete medical report
    deleteReport: async (reportId) => {
        try {
            const response = await api.delete(`/medical-report/${reportId}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to delete medical report');
        }
    },

    // Get patient medical reports
    getPatientReports: async (patientId) => {
        try {
            const response = await api.get(`/medical-report/patient/${patientId}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch patient medical reports');
        }
    }
};
